import * as React from 'react';

import { ButtonsGroup, HeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import { ZoomType } from '../../../containers/Editor/constants';

interface ButtonZoomProps {
	isDisabled: boolean;
	onClick: (zoom: ZoomType) => void;
}

const config = [
	{
		icon: 'iconset_uprez_zoom_out',
		zoom: ZoomType.OUT,
	},
	{
		icon: 'iconset_uprez_zoom_fit',
		zoom: ZoomType.FIT,
	},
	{
		icon: 'iconset_uprez_zoom_in',
		zoom: ZoomType.IN,
	},
];

const ButtonZoom = ({ isDisabled, onClick }: ButtonZoomProps) => (
	<ButtonsGroup>
		{config.map(({ icon, zoom }) => (
			<HeaderButton
				key={zoom}
				iconWidth="35px"
				iconHeight="35px"
				disabled={isDisabled}
				onClick={() => onClick(zoom)}
			>
				{Utils.getSvgIcon(icon)}
			</HeaderButton>
		))}
	</ButtonsGroup>
);

export default ButtonZoom;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonZoom/index.tsx